import styled from 'styled-components';

interface TitleProps {
  fontWeight: number;
}

export const Container = styled.div`
  padding: 4px 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

export const Title = styled.h3<TitleProps>`
  white-space: pre-wrap;
  font-size: 24px;
  color: ${props => props.theme.colors.text};
  font-weight: ${props => props.fontWeight};
  letter-spacing: -0.02em;
  line-height: 1.3;
`;

export const Subtitle = styled.h3`
  white-space: pre-wrap;
  color: ${props => props.theme.colors.grey_text};
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4;
`;
